"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenAsReportSupportedByVisualization = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var includes_1 = tslib_1.__importDefault(require("lodash/includes"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var openAsReportSupportingVisualizations = [
    sdk_ui_1.VisualizationTypes.COLUMN,
    sdk_ui_1.VisualizationTypes.BAR,
    sdk_ui_1.VisualizationTypes.LINE,
    sdk_ui_1.VisualizationTypes.PIE,
];
function isOpenAsReportSupportedByVisualization(type) {
    return includes_1.default(openAsReportSupportingVisualizations, type);
}
exports.isOpenAsReportSupportedByVisualization = isOpenAsReportSupportedByVisualization;
//# sourceMappingURL=visualizationsHelper.js.map